import React from 'react';

import {Radio} from 'semantic-ui-react';

import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveToggle extends React.Component {

    getValueFromOnChange(event, data) {
        return data.checked;
    };

    render() {
        return (
            <AutoSaveField control={Radio}
                           fieldLabel={this.props.fieldLabel}
                           getValueFromOnChange={(event, data) => this.getValueFromOnChange(event, data)}
                           toggle
                           defaultChecked={this.props.defaultValue === true}
                           {...this.props}
            />
        );
    }
}

export default AutoSaveToggle;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveToggle.jsx